export default "__VITE_ASSET__BSX9P8bd__"